export default __webpack_public_path__ + "static/media/radio-button.8c06cf5c.svg";